import { ParameterTypeEnum } from "@commons/enums/parameter-type.enum";

export interface IChartMapData {
    formatData(data: ParameterTypeEnum): number[],
}

export class ChartDefaultMapDataFormmater implements IChartMapData {
    private series: any;
    private theBiggestNumberInChart: number;

    constructor(series: any, theBiggestNumberInChart: number) {
        this.series = series;
        this.theBiggestNumberInChart = theBiggestNumberInChart;
    }

    public formatData(): any {
        if (this.series.parameterType === ParameterTypeEnum.Ignition || this.series.parameterType === ParameterTypeEnum.Binary) {
            return {
                data: this.series.data.map((item: number) => ({
                    value: this.theBiggestNumberInChart * (item === 1 ? (this.series.parameterType === ParameterTypeEnum.Binary ? 0.08 : 0.06) : 0.03),
                    itemStyle: { color: item === 1 ? this.series.color : '#cfcfcf' },
                    parameterType: this.series.parameterType,
                    unit: this.series.unit,
                    value_binary: item,
                })),
                type: 'bar',
                barGap: '50%',
            }
        }

        return {
            data: this.series.data.map(
                (value: number) => ({
                    value: parseFloat(value?.toString().replace(',', '.') || '0').toFixed(2),
                    parameterType: this.series.parameterType,
                    unit: this.series.unit,
                })
            ),
        }
    }
}
